/**
 * DSGVO Cookie Consent fuer Shopify
 * Integration mit Shopify Customer Privacy API
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cw_cookie_consent';
  var STORAGE_VERSION = '1.0';
  var CONSENT_VALIDITY_DAYS = 180; // Einwilligung laeuft nach 180 Tagen ab (DSGVO Empfehlung)

  var el = document.getElementById('cw-cookie-consent');
  var reopenBtn = document.getElementById('cw-cookie-reopen');
  if (!el) return;

  function getSaved() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (data.version !== STORAGE_VERSION) return null;

      var age = (Date.now() - data.timestamp) / (1000 * 60 * 60 * 24);
      if (age > CONSENT_VALIDITY_DAYS) return null;

      return data;
    } catch (e) {
      return null;
    }
  }

  function save(consent) {
    var data = {
      version: STORAGE_VERSION,
      timestamp: Date.now(),
      consent: consent,
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    applyShopifyConsent(consent);
    fireConsentEvent(consent);
  }

  function applyShopifyConsent(consent) {
    // Shopify Customer Privacy API
    // Doku: https://shopify.dev/docs/api/customer-privacy
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        window.Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!consent.analytics,
          marketing: !!consent.marketing,
          preferences: !!consent.preferences,
          sale_of_data: !!consent.marketing,
        }, function () {
          // Callback nach erfolgreichem Setzen
        });
      } catch (e) {
        console.warn('Shopify Customer Privacy API Fehler:', e);
      }
    }
  }

  function fireConsentEvent(consent) {
    // Custom Event fuer andere Scripts (z.B. Google Tag Manager)
    document.dispatchEvent(new CustomEvent('cw:cookie-consent-updated', {
      detail: consent,
    }));

    // GTM/dataLayer Integration
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cookie_consent_update',
      cookie_consent: consent,
    });
  }

  function show() {
    el.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function hide() {
    el.style.display = 'none';
    document.body.style.overflow = '';
    if (reopenBtn) reopenBtn.style.display = 'flex';
  }

  function showDetails() {
    el.querySelectorAll('.cw-cookie-details').forEach(function (c) {
      c.style.display = 'flex';
    });
    el.querySelector('[data-action="save-selection"]').style.display = 'inline-block';
    el.querySelector('[data-action="toggle-details"]').style.display = 'none';
    el.querySelector('.cw-cookie-categories').setAttribute('data-view', 'details');
  }

  function loadCurrentIntoUi() {
    var saved = getSaved();
    if (!saved) return;
    var consent = saved.consent || {};
    el.querySelectorAll('input[data-category]').forEach(function (input) {
      var cat = input.dataset.category;
      if (cat !== 'necessary') {
        input.checked = !!consent[cat];
      }
    });
  }

  function acceptAll() {
    save({ necessary: true, preferences: true, analytics: true, marketing: true });
    hide();
  }

  function rejectAll() {
    save({ necessary: true, preferences: false, analytics: false, marketing: false });
    hide();
  }

  function saveSelection() {
    var consent = { necessary: true };
    el.querySelectorAll('input[data-category]').forEach(function (input) {
      var cat = input.dataset.category;
      if (cat !== 'necessary') {
        consent[cat] = !!input.checked;
      }
    });
    save(consent);
    hide();
  }

  // Event-Handler
  el.addEventListener('click', function (e) {
    var action = e.target.getAttribute('data-action');
    if (!action) return;

    switch (action) {
      case 'accept-all': acceptAll(); break;
      case 'reject-all': rejectAll(); break;
      case 'toggle-details': showDetails(); break;
      case 'save-selection': saveSelection(); break;
    }
  });

  if (reopenBtn) {
    reopenBtn.addEventListener('click', function () {
      loadCurrentIntoUi();
      reopenBtn.style.display = 'none';
      show();
    });
  }

  // Init: Banner zeigen wenn keine Einwilligung vorhanden
  var saved = getSaved();
  if (!saved) {
    show();
  } else {
    if (reopenBtn) reopenBtn.style.display = 'flex';
    applyShopifyConsent(saved.consent);
  }

  // Public API fuer Theme-Entwickler
  window.cwCookieConsent = {
    getConsent: function () {
      var s = getSaved();
      return s ? s.consent : null;
    },
    hasConsent: function (category) {
      var s = getSaved();
      return s && s.consent && !!s.consent[category];
    },
    reopen: function () {
      loadCurrentIntoUi();
      if (reopenBtn) reopenBtn.style.display = 'none';
      show();
    },
    reset: function () {
      localStorage.removeItem(STORAGE_KEY);
      location.reload();
    },
  };
})();
